"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThreeDToolsManager = void 0;
class ThreeDToolsManager {
    constructor(store, bridge) {
        this.store = store;
        this.bridge = bridge;
    }
    updateGrowthOptions(options) {
        this.store.dispatch({
            type: 'toolsOptions/BridgeObjectChanged',
            payload: {
                identifier: 'toolsOptions',
                keyPath: 'growthOptions',
                changes: options,
            },
        });
    }
    updateSpursOptions(options) {
        this.store.dispatch({
            type: 'toolsOptions/BridgeObjectChanged',
            payload: {
                identifier: 'toolsOptions',
                keyPath: 'spursOptions',
                changes: options,
            },
        });
    }
    updateCutOptions(options) {
        this.store.dispatch({
            type: 'toolsOptions/BridgeObjectChanged',
            payload: {
                identifier: 'toolsOptions',
                keyPath: 'cutOptions',
                changes: options,
            },
        });
    }
    updatePainOptions(options) {
        this.store.dispatch({
            type: 'toolsOptions/BridgeObjectChanged',
            payload: {
                identifier: 'toolsOptions',
                keyPath: 'painOptions',
                changes: options,
            },
        });
    }
    updateFractureOptions(options) {
        this.store.dispatch({
            type: 'toolsOptions/BridgeObjectChanged',
            payload: {
                identifier: 'toolsOptions',
                keyPath: 'fractureOptions',
                changes: options,
            },
        });
    }
}
exports.ThreeDToolsManager = ThreeDToolsManager;
